import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const config = (user, params = {}) => ({
  headers: { Authorization: `Bearer ${user.token}` },
  params: { ...params, cache_bust: new Date().getTime() },
});

// Todos dejan pasar el error de axios tal cual: quien llama necesita
// `error.response.data.detail` para explicar un 409 (repetido, entrega
// incompleta, evaluador de la exposición) o un 400 (mail inválido).

// Evaluadores y último aviso de cada grupo del cuatrimestre.
export const getFinalDeliverySummary = async (user, periodId) => {
  const response = await axios.get(
    `${BASE_URL}/final-delivery`,
    config(user, { period: periodId })
  );
  return response.data;
};

// `evaluator` es { user_id } para un tutor o { name, email } para un externo.
export const addFinalEvaluator = async (user, groupId, evaluator) => {
  const response = await axios.post(
    `${BASE_URL}/final-delivery/${groupId}/evaluators`,
    evaluator,
    config(user)
  );
  return response.data;
};

export const removeFinalEvaluator = async (user, groupId, evaluatorId) => {
  await axios.delete(
    `${BASE_URL}/final-delivery/${groupId}/evaluators/${evaluatorId}`,
    config(user)
  );
};

// `reviewDeadline` es "AAAA-MM-DD" (lo que da un <input type="date">): el valor
// de ${fecha_limite}. En la vista previa es opcional; al mandar, el backend la
// exige si la plantilla la usa.
export const previewFinalDeliveryNotice = async (user, groupId, reviewDeadline) => {
  const response = await axios.get(
    `${BASE_URL}/final-delivery/${groupId}/notice`,
    config(user, reviewDeadline ? { review_deadline: reviewDeadline } : {})
  );
  return response.data;
};

export const sendFinalDeliveryNotice = async (user, groupId, { replyTo, reviewDeadline }) => {
  const response = await axios.post(
    `${BASE_URL}/final-delivery/${groupId}/notice`,
    { reply_to: replyTo || null, review_deadline: reviewDeadline || null },
    config(user)
  );
  return response.data;
};

// Aprobación de la entrega final. El evaluador aprueba lo suyo; un admin, lo de
// cualquiera (así aprueba un externo). Devuelve { group_id, approved, evaluators }.
export const approveFinalDelivery = async (user, groupId, evaluatorId, comment) => {
  const response = await axios.post(
    `${BASE_URL}/final-delivery/${groupId}/evaluators/${evaluatorId}/approval`,
    { comment: comment || null },
    config(user)
  );
  return response.data;
};

// Los equipos que evalúa el usuario logueado en el cuatrimestre.
export const getMyEvaluatedGroups = async (user, periodId) => {
  const response = await axios.get(
    `${BASE_URL}/final-delivery/my-groups`,
    config(user, { period: periodId })
  );
  return response.data;
};

// Aprobada cuando hay al menos un evaluador y aprobaron todos. Es la regla del
// backend, para recalcular la lista después de un alta o baja sin pedirla.
export const allApproved = (evaluators) =>
  evaluators.length > 0 && evaluators.every((e) => e.approved_at);

// Marca que un grupo no va a entregar en el cuatrimestre: no se agenda en el
// algoritmo de fechas y su director y evaluadores no cargan disponibilidad por él.
export const markWithdrawal = async (user, groupId, reason) => {
  await axios.put(
    `${BASE_URL}/final-delivery/${groupId}/withdrawal`,
    { reason: reason || null },
    config(user)
  );
};

export const unmarkWithdrawal = async (user, groupId) => {
  await axios.delete(`${BASE_URL}/final-delivery/${groupId}/withdrawal`, config(user));
};

// Les crea cuenta (TUTOR, contraseña aleatoria) a los evaluadores externos del
// cuatrimestre. Devuelve { created: [mails], linked: n, skipped: [{email, reason}] }.
export const createExternalAccounts = async (user, periodId) => {
  const response = await axios.post(
    `${BASE_URL}/final-delivery/external-accounts`,
    {},
    config(user, { period: periodId })
  );
  return response.data;
};
